import { GelList, GelListItem, GelParagraph } from "@tal-gel/components";

const List = ({ content, ordered }) => {
  return (
    <GelList ordered={ordered}>
      {content.split(/\n/).map((p, i) => (
        <GelListItem key={i}>
          <GelParagraph>{p}</GelParagraph>
        </GelListItem>
      ))}
    </GelList>
  );
};

export default List;
